import React from 'react';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { Tooltip } from '@material-ui/core';
import InfoIcon from '@mui/icons-material/Info';

const PreArrival = (props) => {
  const {
    title,
    total,
    subValue,
    isUp,
    showArrow,
    showButton = false,
    androidButtonData,
    iosButtonData,
    width = '250px',
    background = '#fff',
    isInformation,
  } = props;
  const customStyle = {
    background,
  };

  return (
    <div className='analytic-summary-card-pre-email' style={customStyle}>
      <div className='col-12 d-flex justify-content-between align-items-center'>
        <div className='col analytic-summary-card-pre-email-title'>{title}</div>
        {isInformation && (
          <div className='col text-end'>
            <Tooltip title={isInformation} placement='right'>
              <InfoIcon style={{ fontSize: '15px' }} />
            </Tooltip>
          </div>
        )}
      </div>
      <div className='col-12 d-flex gap-2 pt-2 align-items-end'>
        <div className='col analytic-summary-card-pre-email-total'>{total}</div>
        {showButton && (
          <div className='col d-flex align-items-end justify-content-end gap-3'>
            <div className='d-flex align-items-end justify-content-end analytic-summary-card-pre-email-andriod-btn'>
              <div className='bg-white d-flex p-2 device-btn-container'>
                <p className='m-0 fw-bold'>{androidButtonData}</p>
                <p className='m-0 ps-1'>
                  <img
                    src={'../../../assets/icons/android.svg'}
                    className='w-auto h-auto'
                    alt='android'
                  ></img>
                </p>
              </div>
            </div>
            <div className='text-end d-flex align-items-end justify-content-end analytic-summary-card-pre-email-andriod-btn '>
              <div className='bg-white d-flex p-2 device-btn-container'>
                <p className='m-0 fw-bold'>{iosButtonData}</p>
                <p className='m-0 ps-1'>
                  <img
                    src={'../../../assets/icons/apple.svg'}
                    className='w-auto h-auto'
                    alt='ios'
                  ></img>
                </p>
              </div>
            </div>
          </div>
        )}
        {/*Temporary purpose
          {isUp && (
            <div className="analytic-summary-card-pre-email-totalTitle1">
              {showArrow && (
                <ArrowUpwardIcon className="pb-1 ps-1" fontSize="medium" />
              )}
              {subValue}
            </div>
          )}
          {!isUp && (
            <div className="analytic-summary-card-pre-email-totalTitle2">
              {showArrow && (
                <ArrowDownwardIcon className="pb-1 ps-1" fontSize="medium" />
              )}
              {subValue}
            </div>
          )}*/}
      </div>
    </div>
  );
};

export default PreArrival;
